var React = require('react');

function Heart48px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M43.99 21.362l-.003.006-17.44 19.36c-.73.818-1.715 1.271-2.771 1.271h-.002c-1.055 0-2.04-.454-2.771-1.275L3.569 21.368a.02.02 0 0 1-.004-.006C-1.23 16.47-1.22 8.546 3.601 3.67A12.254 12.254 0 0 1 12.37-.001c3.312 0 6.427 1.304 8.769 3.671.004.004.005.009.008.012.004.004.009.005.013.009l2.616 2.804 2.619-2.804c.004-.004.009-.005.013-.009.003-.004.004-.008.008-.012a12.256 12.256 0 0 1 8.769-3.671c3.313 0 6.427 1.304 8.77 3.671 4.816 4.876 4.826 12.801.035 17.692zm-1.441-16.28a10.29 10.29 0 0 0-7.364-3.083c-2.774 0-5.383 1.09-7.349 3.069L24.499 8.64c-.007.007-.017.01-.024.017-.008.008-.011.018-.019.026-.06.057-.133.089-.202.128-.036.021-.067.052-.105.067a.987.987 0 0 1-.373.076.987.987 0 0 1-.373-.076c-.038-.015-.068-.046-.105-.066-.069-.039-.141-.072-.202-.129-.008-.008-.011-.018-.018-.026-.008-.007-.017-.01-.025-.017l-3.325-3.564a10.293 10.293 0 0 0-7.358-3.077 10.295 10.295 0 0 0-7.365 3.083C.942 9.193.942 15.88 5.005 19.989c.006.006.008.015.014.021.005.006.013.007.018.014l17.438 19.36c.355.398.815.614 1.3.614h.001c.486 0 .947-.216 1.299-.611l17.443-19.363c.005-.006.012-.008.017-.013.006-.007.008-.015.014-.021 4.06-4.11 4.06-10.797 0-14.908z","key":1})]);
}

Heart48px.displayName = "Heart48px";

Heart48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.59 42"};

module.exports = Heart48px;

Heart48px.default = Heart48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/heart-48px.svg
// module id = 1142
// module chunks = 0